const main = {
    flexGrow: 1,
    width: '100%',
    /*flexWrap: 'wrap',
    alignContent: 'stretch',
    alignItems: 'stretch',
    flexDirection: 'column',*/
    display: 'grid',
    minHeight: '100%',
    gridAutoRows: '1fr 0fr 1fr',
};
const headerWrapper = {
    flexGrow: { desktop: 0, mobile: 1 },
    width: '100%',
    zIndex: 100,
    position: 'fixed',
};
const footerWrapper = {
    flexGrow: 1,
    width: '100%',
    zIndex: 200,
};
const sideBarAndMainContainer = {
    alignSelf: 'stretch',
    flex: '1 1 auto',
    width: { desktop: 'unset', mobile: '100vw' },
    mt: '60px',
};
const sideBarWrapper = { width: 0, zIndex: 200, position: 'fixed', height: '100%' };
const childrenWrapper = {
    flexGrow: 1,
    width: '100%',
};
const contentWrapper = (isDesktop) => {
    return {
        flexGrow: 1,
        zIndex: isDesktop ? 10 : 9,
        marginLeft: isDesktop ? '120px' : 0,
        width: isDesktop ? `calc(100% - 120px)` : '100%',
        alignSelf: 'stretch',
        flex: '0 1 auto',
    };
};
export default {
    main,
    footerWrapper,
    sideBarAndMainContainer,
    headerWrapper,
    sideBarWrapper,
    childrenWrapper,
    contentWrapper,
};
